export default __webpack_public_path__ + "static/media/Canis1_desktop.7260238f.png";